import React,{useContext,useState,useEffect} from "react";
import { format,subDays } from "date-fns";
import { Box,Typography,Button,IconButton } from "@mui/material";
import TextField from '@mui/material/TextField';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate,useParams } from 'react-router-dom';
import { VehicleHistoryContext } from "../Context/VehicleHistoryContext";
import { CalendarMonth } from "@mui/icons-material";
import DialogHistoryDateSelector from "./DialogHistoryDateSelector";

export  default function HistoryDateSelector({id,isLargeScreen}){

	const vhContext = useContext(VehicleHistoryContext)
	const navigate = useNavigate()
	const [startTime, setStartTime] =useState(format(subDays(new Date(),7),"yyyy-MM-dd\'T\'HH:mm"))
    const [endTime, setEndTime] =useState(format(new Date(),"yyyy-MM-dd\'T\'HH:mm"))

	const [dialogMobileDateSelectorOpen,setDialogMobileDateSelectorOpen] = useState(false)
	useEffect(() => {
		vhContext.loadVehicle(id)
		onGoClicked()
	},[])

	const onGoClicked = () => {
        vhContext.loadCoorPoints(id,startTime,endTime)
    }
	return(
		isLargeScreen ?
		<Box>
			<Box style={{display : "flex", flexDirection : "row", alignItems: "center",justifyContent : "space-between", padding : "0.5rem"}} >
                    <Box><IconButton onClick={() => {navigate("/dashboard")}}><ArrowBackIcon /><Typography variant="h6">Back</Typography></IconButton></Box>
                    <Box><Typography variant="h5" style={{color : "#013371"}}>History : {vhContext.vehicle.name}</Typography></Box>
                    <Box sx={{width : "80px"}}></Box>
			</Box>
			<Box display={"flex"} mb="1rem" justifyContent={"center"} alignItems="center">
				
				<Typography variant='body1'>Dari :</Typography>
				<TextField onChange={(e) => {setStartTime(e.target.value)}} type={"datetime-local"} sx={{ml : "0.25rem", mr : "1rem"}}  defaultValue={startTime} size="small"/>
				<Typography variant='body1'>Sampai :</Typography>
				<TextField onChange={(e) => {setEndTime(e.target.value)}} type={"datetime-local"}  sx={{ml : "0.25rem", mr : "1rem"}} defaultValue={endTime}  size="small"/>
				<Button variant="contained" onClick={() => {onGoClicked()}}>GO</Button>
			</Box>
		</Box>
		:
		<Box sx={{pt : 1}}>
			<Box style={{display : "flex", flexDirection : "row", alignItems: "center",justifyContent : "space-between", paddingLeft : 1,paddingRight : 1,paddingTop : 2, paddingBottom : 0}} >
                    <Box width={"10%"} pl={1}>
					<IconButton onClick={() => {navigate("/dashboard")}}>
						<ArrowBackIcon />
						<Typography variant="subtitle2">Back</Typography>
					</IconButton>
				</Box>
				<Box display={"flex"} width={"80%"} alignItems={"center"} flexDirection={"column"} justifyContent={"center"}>

					<Typography variant="subtitle1" sx={{textAlign : "center",color : "#013371",fontWeight : "bold"}} >{vhContext.vehicle.name}</Typography>
					
				</Box>
				<Box width={"10%"} pr={1}>
					<IconButton 
					onClick={() => {console.log("Test");setDialogMobileDateSelectorOpen(true)}}>
						<CalendarMonth />
					</IconButton>
				</Box>
			</Box>
			<Box>
				<Typography variant="body2" sx={{textAlign : "center"}} >
					{format(new Date(startTime),"dd MMM yyyy HH:mm")} - {format(new Date(endTime),"dd MMM yyyy HH:mm")}
				</Typography>
			</Box>
			
			<DialogHistoryDateSelector 
				open={dialogMobileDateSelectorOpen} 
				onClose={() => {setDialogMobileDateSelectorOpen(false)}}
				onGoClicked={() => {
					onGoClicked()
					setDialogMobileDateSelectorOpen(false)
				}}
				startTime={startTime}
				endTime={endTime}
				setStartTime={setStartTime}
				setEndTime={setEndTime}
			/>
			
		</Box>
	)

}